module.exports = __webpack_public_path__ + "static/assets/d763b19cb987b4a205100680a09cd742.png";